

export const loremBase = `Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
Proin eget venenatis orci. Nulla facilisi. Proin erat dolor, feugiat ac eleifend eget, convallis tristique lectus. 
Suspendisse bibendum tempor condimentum. Nullam semper varius ipsum vel euismod. Nunc convallis interdum tellus nec bibendum. 
Donec at quam ac justo lobortis dignissim. Aenean euismod pretium velit eu ullamcorper. Nulla non justo nec ante blandit fringilla.
 Phasellus ac fringilla eros, et mollis turpis. Cras ornare leo a mauris posuere, vehicula pulvinar metus pellentesque. 
 Nam luctus est quis facilisis consectetur.  Etiam ornare lacus quis massa tempus, et vulputate mi viverra.`

 export const lorem = ( len ) => {
     return loremBase.slice(0, len)
 } 

 


